export const productSearchSuggestionQuery = /* GraphQL */ `
    query categories(
        $search: String
        $pageSize: Int = 3
        $currentPage: Int = 0
    ) {
        products(
            search: $search
            pageSize: $pageSize
            currentPage: $currentPage
        ) {
            total_count
            aggregations {
                label

                attribute_code
                options {
                    label
                    value
                    __typename
                }
                __typename
            }
            items {
                name

                price_range {
                    __typename
                    minimum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                    maximum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                }

                small_image {
                    __typename
                    url
                }
                url_key
            }
        }
    }
`

export const productSearchSuggestionQuery2 = `
query productSearch(
    $phrase: String!
    $page_size: Int = 10
    $current_page: Int = 1
) {
    productSearch(
        phrase: $phrase
        page_size: $page_size
        current_page: $current_page
    ) {
        total_count
        search_request_id
        facets {
            attribute
            title
            buckets {
                title
            }
        }
        suggestions
        items {
            name
            canonical_url
            sku
            price_range {
                __typename
                minimum_price {
                    __typename
                    regular_price {
                        __typename
                        value
                        currency
                    }
                    final_price {
                        __typename
                        value
                        currency
                    }
                    discount {
                        __typename
                        amount_off
                        percent_off
                    }
                }
                maximum_price {
                    __typename
                    regular_price {
                        __typename
                        value
                        currency
                    }
                    final_price {
                        __typename
                        value
                        currency
                    }
                    discount {
                        __typename
                        amount_off
                        percent_off
                    }
                }
            }
            small_image {
                __typename
                url
            }
        }
    }
}
`
